<template>
    <ubi-panel>
        <el-row :gutter="25">
            <el-col :xs="24" :sm="24" :md="12" :lg="12" :xl="12"  id="privateNoteDecription">
                <h3>{{post.titre}}</h3>
                <br/>
                <el-tag id="tagLeft">{{ post.typeBienLibelle}}</el-tag>
                <el-tag>{{ post.typeOffreLibelle }}</el-tag>
                <br/><br/>
                <h4>{{ $t("posts.privateNote.generalInformationTitle") }}</h4>
                <br/>
                <div v-if="post.reference">{{ $t("posts.privateNote.postReference") }} : {{post.reference}}</div>
                <div v-if="post.prixDisplay">{{ $t("posts.privateNote.postPrice") }} : {{post.prixDisplay}}</div>
                <div v-if="post.ville && post.code_postal">{{ $t("posts.privateNote.postLocation") }} : {{post.code_postal}} {{post.ville}}</div>
                <div v-if="post.surface_habitable">{{ $t("posts.privateNote.postLocation") }} : {{post.surface_habitable}} m²</div>
                <div v-if="post.nb_pieces_logement">{{ $t("posts.privateNote.PostNumberRoom") }} : {{post.nb_pieces_logement}}</div>
            </el-col>
            <el-col :xs="24" :sm="24" :md="12" :lg="12" :xl="12">
                <el-image id="imageAgranditPrivateNote" v-if="post.photoPrincipale != null"
                          :src="post.photoPrincipale.url" fit="contain"></el-image>
                <div class="text-center" v-else>
                    <ubi-icon class="no-photo" name="camera" size='250'/>
                </div>
            </el-col>
        </el-row>
    </ubi-panel>
</template>

<script>

export default {
  name: 'PrivateNoteImmo',
  props: ['post']
}
</script>

<style scoped>
    #tagLeft{
        margin-right: 10px;
    }

    #privateNoteDecription{
        border-right: #e0dbdf solid 0.2px;
    }

    #imageAgranditPrivateNote{
        width: 100%;
    }
    @media screen and (max-width: 760px) {
        #privateNoteDecription{
            border-bottom: #e0dbdf solid 0.2px;
        }
    }

</style>
